<template>
  <div class="user-research">
    <userresearch />
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import Userresearch from '@/components/user-research/UserResearch'

export default {
  name: 'UserResearch',
  components: {
    Userresearch
  },
  created () {
    EventBus.$emit('onLoading', false)
  }
}
</script>

<style lang="scss" scoped>
.user-research { }
</style>
